import { render, staticRenderFns } from "./socioListList.vue?vue&type=template&id=08e6cadd"
import script from "./socioListList.vue?vue&type=script&lang=js"
export * from "./socioListList.vue?vue&type=script&lang=js"
import style0 from "./socioListList.vue?vue&type=style&index=0&id=08e6cadd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports